import { render, staticRenderFns } from "./inquisitor.vue?vue&type=template&id=c73d4712&scoped=true"
import script from "./inquisitor.vue?vue&type=script&lang=js"
export * from "./inquisitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73d4712",
  null
  
)

export default component.exports